import { root, about, nonAbout } from "./container.module.css";
// import classNames from "classnames"
import React from "react";


const Container = ({children, templateType = ""}) => {
  return <div className={`${root} ${templateType == "about" ? about : templateType}`}>{children}</div>
}

export default Container